export default "__VITE_ASSET__f618246e__"